import { z } from 'zod';

import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';
import { basicUrlRegex } from '~/utils/validation/url';

export const getSchema = ({ t }) => {
  return z
    .object({
      url: z
        .string()
        .regex(basicUrlRegex, { message: t('errors:url_2') })
        .max(1500, t('errors:max', { count: 1500 }))
        .refine(
          (val) => {
            try {
              const url = new URL(val.includes('http') ? val : `http://${val}`);
              const parts = url.hostname.split('.');

              // Check length of each subdomain (before domain + TLD)
              const subdomains = parts.slice(0, -2);
              if (subdomains.some((s) => s.length > 63)) return false;

              const domain = parts[parts.length - 2];
              const tld = parts[parts.length - 1];

              return domain.length <= 63 && tld.length <= 63;
            } catch {
              return false;
            }
          },
          { message: t('errors:url_2') },
        ),
    })
    .merge(getGeneralStaticBuilderSchema());
};
